// extracted by mini-css-extract-plugin
export default {"description":"news_description__xF5M7","content":"news_content__LiJJU"};